<template>
  <!--Свернутое меню -->
  <div class="right-menu uk-flex uk-flex-between uk-flex-column uk-height-1-1">
    <div class="right-menu-box">
      <div @click="toggleMenu">
        <span class="right-menu-icon" uk-icon="icon: more-vertical; ratio: 1.5"></span>
        <div class="right-menu-icon-hover">
          <span class="right-menu-icon" uk-icon="icon: chevron-left; ratio: 1.5"></span>
        </div>
      </div>
    </div>
    <RightMenuLogoutButton className="right-menu-box" />
    <BClock />
  </div>
</template>

<script>
import RightMenuLogoutButton from '@/views/layout/desktop/right_menu/RightMenuLogoutButton'
import BClock from '@/components/b-clock'

export default {
  name: 'DesktopRightMenuClosed',
  components: {RightMenuLogoutButton, BClock},
  methods: {
    toggleMenu() {
      this.$emit('change', true)
    }
  }
}
</script>
